import React from 'react';

const AnalyzeFinancial = () => <h1 className="pageTitle">Financial</h1>;

export default AnalyzeFinancial;
